import {useState} from 'react';
import Modal from '@mui/material/Modal';
import './RaiseRequest.css';
const RaiseRequest = () =>{
    const [show, setShow] = useState(false);
    const handleOpenModal = () => {
        setShow(true);
    };
  
    const handleCloseModal = () => {
        setShow(false);
    };
    return (
        <>
         <div className="float-box box5">
          <p>
            <a onClick={handleOpenModal}>
              <img
                src="images/Home/raiserequesticon.png"
                alt="icons"
                className="float-icons"
              />
              Looking for Learning? Raise request here
            </a>
          </p>
          <Modal
                open={show}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className="model-main"
            >
                <div className="model-container">
                <span id="thankYou-close" onClick={handleCloseModal}>
                </span>
                <div className="feedback_label">Raise Request</div>
                <div className="model_heading_reqtraining">
                    <p className="model_name_reqtraining">
                    <a
                        href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/a717c9aa-f39d-4070-bdb5-e1e3d6fd50b4?tenantId=e0793d39-0939-496d-b129-198edd916feb&sourcetime=1732794644453&source=portal#"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Link to raise request
                    </a>
                    </p>
                </div>
                </div>
            </Modal>
        </div>
        </>
    )
}

export default RaiseRequest;